<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-row style="min-height: 100vh;" align="center" justify="space-around">
          <v-card
            dark
            hover
            @click="selected(item)"
            :img="item.backgroundImage"
            v-for="item in listItem"
            :key="item.title"
          >
            <v-img height="240px" width="200px" :src="item.imgLogo"></v-img>
            <v-card-title style="color: white;">{{item.title}}</v-card-title>
          </v-card>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { bus } from "@/main";
  import conf from "@/configs";
  
  export default {
    data() {
      return {
        listItem: conf.listItem,
      };
    },

    methods: {
      selected(item) {
        bus.$emit("appChange", item);
        this.$router.push({ path: item.link });
      }
    }
  };
</script>